export type URLS = Record<string, string>;

export function resolveDefaultURLS(build: (...parts: string[]) => string) {
  return {
    CurrentCartURL: build("cart/"),
    CartBatchOperationURL: build("cart", "batch"),
    CartTryBatchOperationURL: build("cart", "batch", "try"),
  
    GetPaymentMethodsURL: build("checkout", "payments"),
    GetDeliveryMethodsURL: build("checkout", "deliveries"),
    FreePaymentMethodURL: build("checkout", "payments", "free"),
  
    GetSettingsURL: build("checkout", "settings/"),
    TryFeesURL: build("checkout", "settings", "try"),
    ApplyFeesURL: build("checkout", "settings", "apply"),
  
    BuyURL: build("checkout", "buy"),

    ListPublicRebatesURL: build("rebate"),
    ApplyRebateURL: build("rebate/apply"),
    CheckRebateURL: build("rebate/check"),
    CheckSettingsURL: build("rebate/settings"),
    CheckEngineURL: build("rebate/engine"),
  
    ListEventsURL: build("events"),
    PriceDataURL: build("event", ":id", "price_data"),
    ContingentURL: build("event", ":id", "contingent"),
    EventImageURL: build("event", ":id", "image"),
    GetChartURL: build("event", ":id", "chart/"),
    ChartBackgroundURL: build("event", ":id", "chart", "background"),
    GetBlockURL: build("event", ":id", "chart", "block", ":block_id"),
  
    ApplyCouponCodeURL: build("cart", "coupon"),
    AddGiftCoupon: build("cart", "giftcard"),
    AddRebateCoupon: build("cart", "rebate"),
    
    ShowFormsURL: build("cart", "forms"),

    ReceiptURL: build("booking", ":uuid", "receipt"),
    TicketURL: build("booking", ":uuid", "ticket"),

    BundleStartURL: build("bundles", "start", ":id"),
    BundlePrepareURL: build("bundles", "prepare", ":id"),
    BundleStateURL: build("bundles", "wizard", ":selector_id"),
    BundleSetSeatURL: build("bundles", "wizard", ":selector_id", "seat", ":preselect_id", "set", ":seat_id"),
    BundleClearSeatURL: build("bundles", "wizard", ":selector_id", "seat", ":preselect_id", "clear"),
    BundleSubmitURL: build("bundles", "wizard", ":selector_id", "submit")
  }
}
